import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { getPurchaseList } from "@/api/purchase/getPurchaseList";

export function PurchaseList() {
  const query = getPurchaseList.useQuery();

  if (query.isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (query.isError) {
    return (
      <Alert severity="error">
        Failed to load purchases: {JSON.stringify(query.error)}
      </Alert>
    );
  }

  const purchases = query.data ?? [];

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: "calc(100vh - 160px)" }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Order #</TableCell>
            <TableCell>Supplier</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Order date</TableCell>
            <TableCell>Invoice #</TableCell>
            <TableCell align="right">Invoice amount</TableCell>
            <TableCell align="right">Paid amount</TableCell>
            <TableCell>Receiving</TableCell>
            <TableCell>Invoice status</TableCell>
            <TableCell>Payment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {purchases.map((purchase) => (
            <TableRow key={purchase.id} hover>
              <TableCell>{purchase.orderNumber}</TableCell>
              <TableCell>{purchase.supplier}</TableCell>
              <TableCell>{purchase.status}</TableCell>
              <TableCell>{purchase.orderDate}</TableCell>
              <TableCell>{purchase.invoiceNumber}</TableCell>
              <TableCell align="right">{purchase.invoiceAmount}</TableCell>
              <TableCell align="right">{purchase.paidAmount}</TableCell>
              <TableCell>{purchase.combinedReceivingStatus}</TableCell>
              <TableCell>{purchase.combinedInvoiceStatus}</TableCell>
              <TableCell>{purchase.combinedPaymentStatus}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
